import React, { useState } from "react";
import PropTypes from "prop-types";
import { CheckOutlined, ContentCopyOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

// Icon-only copy-to-clipboard control with an accessible label and a brief
// "Copied" confirmation state. Used anywhere a long ID/OID/email needs a
// one-click copy affordance (tables, detail drawers).
const CopyIconButton = ({ value, label = "Copy", size = "small" }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value ?? "");
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard API can be unavailable (insecure context, permissions) — fail silently.
    }
  };

  if (!value) return null;

  return (
    <Tooltip title={copied ? "Copied!" : label}>
      <IconButton
        size={size}
        onClick={handleCopy}
        aria-label={copied ? "Copied" : label}
        sx={{ color: copied ? "#26890d" : "#9ca3af" }}
      >
        {copied ? <CheckOutlined fontSize="inherit" /> : <ContentCopyOutlined fontSize="inherit" />}
      </IconButton>
    </Tooltip>
  );
};

CopyIconButton.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.oneOf(["small", "medium"]),
};

export default CopyIconButton;
